import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import RecommendPc from '@/components/Recommend';
import RecommendH5 from '@/componentsH5/Recommend';
import Crum from '@/components/Crum';
import {
    EFWaterHeater,
    EFFan,
    EFCoffeeMake,
    EFFridge,
    EFMicroware,
    EFLight,
    EFLaptop,
    EFCrockpot,
    EFAirConditioner,
    EFDryer,
    EFCooktop,
} from '@/components/UI/svg/recommend';
import IRAHeader from '@/components/IRAComp/IRAHeader';
import IRAFooter from '@/components/IRAComp/IRAFooter';

export default function Recommend({}: any) {
    const { isMobile, useLang, useRouter, useState } = useGlobal();
    const { t } = useLang('powerkitsrecommend');
    const { locale } = useRouter();
    const RecommendHtml = isMobile ? RecommendH5 : RecommendPc;
    const breadcrumbData = [
        { name: t('crums.crum_home'), link: '/' },
        { name: t('crums.curm_power_kit'), link: '/ecoflow-power-kits/series' },
        { name: t('crums.curm_recommend') },
    ];
    const tabData = [
        {
            tabIndex: 0,
            title: t('tab1'),
            content: [
                {
                    bundleTitle: t('tab1_content.bundle_title1'),
                    title: t('tab1_content.title1'),
                    subTitle: t('tab1_content.sub_title1'),
                    img: '/img/recommend/tab1_1.jpg',
                    linkParams: '2kWh',
                    modalData: [
                        { svg: <EFLight width="32px" height="32px" />, title: t('modal.lights'), params: t('modal.16h') },
                        { svg: <EFLaptop width="32px" height="32px" />, title: t('modal.laptop'), params: t('modal.6h') },
                        { svg: <EFFan width="32px" height="32px" />, title: t('modal.fan'), params: t('modal.6h') },
                        { svg: <EFCrockpot width="32px" height="28px" />, title: t('modal.crockpot'), params: t('modal.1h') },
                        { svg: <EFCoffeeMake width="32px" height="32px" />, title: t('modal.coffee_maker'), params: t('modal.0_5h') },
                    ],
                },
                {
                    bundleTitle: t('tab1_content.bundle_title2'),
                    title: t('tab1_content.title2'),
                    subTitle: t('tab1_content.sub_title2'),
                    img: '/img/recommend/tab1_2.jpg',
                    linkParams: '10kWh',
                    modalData: [
                        { svg: <EFFridge width="32px" height="32px" />, title: t('modal.fridge'), params: t('modal.24h') },
                        { svg: <EFLight width="32px" height="32px" />, title: t('modal.lights'), params: t('modal.16h') },
                        { svg: <EFAirConditioner width="32px" height="32px" />, title: t('modal.air_conditioner'), params: t('modal.6h') },
                        { svg: <EFCrockpot width="32px" height="32px" />, title: t('modal.crockpot'), params: t('modal.2h') },
                        { svg: <EFMicroware width="32px" height="32px" />, title: t('modal.microwave'), params: t('modal.0_5h') },
                    ],
                },
            ],
        },
        {
            tabIndex: 1,
            title: t('tab2'),
            content: [
                {
                    bundleTitle: t('tab2_content.bundle_title1'),
                    title: t('tab2_content.title1'),
                    subTitle: t('tab2_content.sub_title1'),
                    img: '/img/recommend/tab2_1.jpg',
                    linkParams: '5kWh',
                    modalData: [
                        { svg: <EFFridge width="32px" height="32px" />, title: t('modal.fridge'), params: t('modal.24h') },
                        { svg: <EFLight width="32px" height="32px" />, title: t('modal.lights'), params: t('modal.16h') },
                        { svg: <EFLaptop width="32px" height="32px" />, title: t('modal.laptop'), params: t('modal.6h') },
                        { svg: <EFMicroware width="32px" height="32px" />, title: t('modal.microwave'), params: t('modal.1h') },
                        { svg: <EFWaterHeater width="32px" height="32px" />, title: t('modal.water_heater'), params: t('modal.0_5h') },
                    ],
                },
                {
                    bundleTitle: t('tab2_content.bundle_title2'),
                    title: t('tab2_content.title2'),
                    subTitle: t('tab2_content.sub_title2'),
                    img: '/img/recommend/tab2_2.jpg',
                    linkParams: '15kWh',
                    modalData: [
                        { svg: <EFFridge width="32px" height="32px" />, title: t('modal.fridge'), params: t('modal.24h') },
                        { svg: <EFLight width="32px" height="32px" />, title: t('modal.lights'), params: t('modal.16h') },
                        { svg: <EFAirConditioner width="32px" height="32px" />, title: t('modal.air_conditioner'), params: t('modal.6h') },
                        { svg: <EFCooktop width="32px" height="32px" />, title: t('modal.cooktop'), params: t('modal.1_5h') },
                        { svg: <EFWaterHeater width="32px" height="32px" />, title: t('modal.water_heater'), params: t('modal.0_5h') },
                    ],
                },
            ],
        },
        {
            tabIndex: 2,
            title: t('tab3'),
            content: [
                {
                    bundleTitle: t('tab3_content.bundle_title1'),
                    title: t('tab3_content.title1'),
                    subTitle: t('tab3_content.sub_title1'),
                    img: '/img/recommend/tab3_1.jpg',
                    linkParams: '15kWh',
                    modalData: [
                        { svg: <EFFridge width="32px" height="32px" />, title: t('modal.fridge'), params: t('modal.72h') },
                        { svg: <EFLight width="32px" height="32px" />, title: t('modal.lights'), params: t('modal.48h') },
                        { svg: <EFAirConditioner width="32px" height="32px" />, title: t('modal.air_conditioner'), params: t('modal.18h') },
                        { svg: <EFCooktop width="32px" height="32px" />, title: t('modal.cooktop'), params: t('modal.4_5h') },
                        { svg: <EFWaterHeater width="32px" height="32px" />, title: t('modal.water_heater'), params: t('modal.1_5h') },
                    ],
                },
                {
                    bundleTitle: t('tab3_content.bundle_title2'),
                    title: t('tab3_content.title2'),
                    subTitle: t('tab3_content.sub_title2'),
                    img: '/img/recommend/tab3_2.jpg',
                    linkParams: '15kWh',
                    linkType: 'popup',
                    modalData: [
                        { svg: <EFFridge width="32px" height="32px" />, title: t('modal.fridge'), params: t('modal.120h') },
                        { svg: <EFAirConditioner width="32px" height="32px" />, title: t('modal.air_conditioner'), params: t('modal.18h') },
                        { svg: <EFMicroware width="32px" height="32px" />, title: t('modal.microwave'), params: t('modal.4h') },
                        { svg: <EFDryer width="32px" height="32px" />, title: t('modal.dryer'), params: t('modal.3h') },
                        { svg: <EFWaterHeater width="32px" height="32px" />, title: t('modal.water_heater'), params: t('modal.3h') },
                    ],
                },
            ],
        },
    ];

    const data = {
        us: '3',
        eu: '5',
        ca: '4',
        au: '11',
        uk: '6',
        kr: '10',
        de: '7',
        fr: '8',
        jp: '9',
        cn: '12',
    };
    const activityId = data[locale as keyof typeof data];

    return (
        <PageLayout
            className={css.recommend}
            navChildren={
                <>
                    <IRAHeader isMM100={true} />
                    <Crum data={breadcrumbData} />
                    <RecommendHtml tabData={tabData} activityId={activityId} />
                    <IRAFooter
                        bgColor="#fff"
                        borderTopColor="#ebe9e9"
                        titleColor="#777"
                        boxStyle={isMobile ? {} : { width: '980px', paddingBottom: '100px' }}
                    />
                </>
            }
        ></PageLayout>
    );
}

// 以下两个方法不可删除，否则会重复触发 _app.js 中 getInitialProps 中的请求
export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = ['us'];
    // let whiteLocaleList = []
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404(locale);
    }
    return {
        props: {},
    };
}
